import config from '@/config';
import { LogicContext } from '@/logic/main/types';
import { groupItemsByTypes, mapGamesWithJackpotsV2 } from '@/logic/main/utils';
import { SEARCH_RESULT_CATEGORY_ID } from '@/model/constants';
import { getLocale } from '@/utils';

export const fetchSearchResultsContent = async (context: LogicContext) => {
  const {
    search: { searchItems, currentType },
    controllersData,
  } = context;
  const locale = getLocale(config);
  const currency = context.user?.currency || config.default_currency;

  const gamesWithJackpotV2 = mapGamesWithJackpotsV2(
    searchItems,
    context.currentJackpotsV2
  );
  const grouppedItems = groupItemsByTypes(gamesWithJackpotV2);

  const [, searchHeader] =
    controllersData.search?.components.find(
      ([, comp]) => comp.type === 'SearchHeader'
    ) || [];

  const [, searchCategoryComponent] =
    controllersData.search?.components.find(
      ([, comp]) => comp.type === 'SearchCategory'
    ) || [];

  const searchCategory = {
    component_type: 'game_grid',
    id: SEARCH_RESULT_CATEGORY_ID,
    title:
      searchCategoryComponent?.properties?.staticTexts?.searchTitle ??
      'Search Results',
    type: 'Game List',
    staticTexts: {
      ...searchHeader?.properties.staticTexts,
      gameInfoTooltip:
        searchCategoryComponent?.properties?.staticTexts?.gameInfoTooltip,
    },
    slides: [
      {
        type: 'Game List',
        gameList: grouppedItems[currentType],
        gamesLimit: undefined,
      },
    ],
  };

  return {
    updates: [
      {
        type: 'hideLayoutComponent',
        data: `SearchNoResults`,
      },
      {
        type: 'hideLayoutComponent',
        data: `SearchNoResultsDesktop`,
      },
      {
        type: 'hideLayoutComponent',
        data: `SearchHeader`,
      },
      {
        type: 'hideLayoutComponent',
        data: `SearchResults`,
      },
      {
        type: 'showLayoutComponent',
        data: `SearchMoreResults`,
      },
      {
        type: 'setLayoutProperty',
        data: {
          path: `components.SearchResultsCategory.properties`,
          value: {
            category: searchCategory,
            locale,
            currency,
          },
        },
      },
    ],
  };
};
